import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Navigation from './components/Navigation'
import Index from './pages/Index'
import AddProducts from './pages/AddProducts'
import UpdateProduct from './pages/UpdateProduct'

export default () => (
  <>
    <Router>
      <Navigation />
      <Route path='/' exact component={Index} />
      <Route path="/add-products" component={AddProducts} />
      <Route path="/update-product/:id" component={UpdateProduct} />
    </Router>
  </>
)